import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./Featurecard.css";
import mascotVerified from "/public/SiteImages/personaje-verificado.svg";

function ShieldIcon() {
  return (
    <svg
      viewBox="0 0 24 26"
      width="38"
      height="40"
      fill="none"
      stroke="#00C987"
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2L4 5.5V12C4 17.5 7.5 22.5 12 24C16.5 22.5 20 17.5 20 12V5.5L12 2Z" />
      <polyline points="9 12.5 11 14.5 15.5 10" />
    </svg>
  );
}

function UsersIcon() {
  return (
    <svg
      viewBox="0 0 34 26"
      width="42"
      height="34"
      fill="none"
      stroke="#00C987"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Center user */}
      <circle cx="17" cy="7" r="4" />
      <path d="M11 22C11 18.7 13.7 16 17 16C20.3 16 23 18.7 23 22" />
      {/* Left user */}
      <circle cx="7" cy="10" r="3.2" />
      <path d="M2 22C2 19.5 3.8 17.5 6.2 17.1" />
      {/* Right user */}
      <circle cx="27" cy="10" r="3.2" />
      <path d="M32 22C32 19.5 30.2 17.5 27.8 17.1" />
    </svg>
  );
}

function FeaturesSection() {
  return (
    <section className={s["eh-features"]} id="por-que-eslipin">
      <div className={s["eh-features__container"]}>
        <h2 className={s["eh-features__heading"]}>
          ¿Por qué publicar en Eslipin?
        </h2>

        <div className={s["eh-features__grid"]}>
          {/* Card 1: 0% Comisión */}
          <div className={s["eh-card"]}>
            <div className={s["eh-card__icon-badge"]}>
              <span className={s["eh-card__percent-badge"]}>0%</span>
            </div>
            <h3 className={s["eh-card__title"]}>0% de comisión</h3>
            <p className={s["eh-card__desc"]}>
              Lo que ganas es tuyo. Eslipin no te cobra comisión por tus reservas.
            </p>
          </div>

          {/* Card 2: Pagos seguros */}
          <div className={s["eh-card"]}>
            <div className={s["eh-card__icon-badge"]}>
              <ShieldIcon />
            </div>
            <h3 className={s["eh-card__title"]}>Pagos seguros</h3>
            <p className={s["eh-card__desc"]}>
              Recibe el dinero en el momento, con el respaldo del sistema de pago seguro de Eslipin.
            </p>
          </div>

          {/* Card 3: Huéspedes verificados */}
          <div className={`${s["eh-card"]} ${s["eh-card--with-mascot"]}`}>
            <div className={s["eh-card__mascot-wrapper"]}>
              <img
                src={mascotVerified}
                alt="Huéspedes verificados"
                className={s["eh-card__mascot-img"]}
              />
            </div>
            <div className={s["eh-card__icon-badge"]}>
              <UsersIcon />
            </div>
            <h3 className={s["eh-card__title"]}>Huéspedes verificados</h3>
            <p className={s["eh-card__desc"]}>
              Perfiles verificados y con historial visible para que aceptes reservas con tranquilidad.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default withStyles(s)(FeaturesSection);

